import { Outlet, useLocation } from "react-router";
import { Suspense, useEffect } from "react";
import Navbar from "../core/common/header/Navbar"; // Import your custom Navbar
import BackToTop from "../core/common/backtotop/backToTop";
import Footer from "./HomePages/home-four/footer";
import { scrollToTopReliably } from "../utils/scrollToTop";
import PageLoader from "../core/common/pageLoader/PageLoader";

const Feature = () => {
  const location = useLocation();

  // A link to a section (#helper …) lets the page scroll there itself
  useEffect(() => {
    if (!location.hash) scrollToTopReliably();
  }, [location.pathname, location.hash]);

  return (
    <>
      <div className="main-wrapper">
        <div
          className={
            location.pathname === "/index-3"
              ? "home-3"
              : location.pathname === "/index-4"
              ? "home-4"
              : location.pathname === "/index-6"
              ? "home-six"
              : ""
          }
        >
          {/* 🔁 Conditionally render Navbar only for index-4 */}
          <Navbar />

          {/* at least one screen high, so the footer doesn't flash at the top while a page loads */}
          <main className="min-h-[100vh]">
            {/* Navbar and footer stay while the page's code loads */}
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </main>

          <Footer />

          <BackToTop />
        </div>

        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;
